module.exports = __webpack_public_path__ + "static/img/enter4.82e3ad6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/enter4.jpg
// module id = Stx3
// module chunks = 1